export default {
  NETWORK_RETRY_INTERVAL: 5, // in seconds
  NETWORK_RETRY_MAX_COUNT: 3, // before giving up

  CLIENT: {
    VERSION: '1.0.7',
  },

  SUPPORT: {
    EMAIL: 'support@pagehits.io',
    DEFAULT_SUBJECT: 'Support request',
    DEFAULT_BODY: 'Hi PageHits',
  },

};



// WEBPACK FOOTER //
// ../config/params.base.js